import { Eye } from "lucide-react";

/**
 * TownEye logo — matches the mobile app header:
 * "TownEye" wordmark with the small purple eye-icon prefix.
 */
export function TownEyeLogo({ size = 22, withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      {withText && (
        <span
          className="font-extrabold tracking-tight text-[var(--te-text)]"
          style={{ fontSize: size + 6, lineHeight: 1 }}
        >
          TownEye
        </span>
      )}
      <Eye
        size={size}
        strokeWidth={2.2}
        className="text-[var(--te-primary)]"
      />
    </div>
  );
}
